<template>
  <div ref="vueRemove">
    <!-- Modal stripeModal -->
    <div class="modal fade text-black" ref="stripeModal" :id="$id('stripeModal')" data-backdrop="static" data-keyboard="false" tabindex="-1" :aria-labelledby="$id('payLabel')" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title heading" :id="$id('payLabel')">{{ location.name }} Payment</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div v-if="timeLeftToPay && timeLeftToPay.asMinutes() < 60" class="mb-2">
              Please complete your payment in the next<br>
              <strong class="text-monospace">{{ timeLeftToPayFormatted }}</strong>
            </div>
            <div v-if="timeExpired" class="mb-2 text-red font-weight-bold">
              Sorry you did not complete your payment in time.
            </div>

            <div class="mb-2">
              Amount to pay: <strong v-if="sale">{{ amountToPay | money }}</strong>
            </div>

            <div v-show="prButtonShow" ref="paymentRequestFG" class="form-group">
              <div ref="paymentRequestButton">
                <!-- A Stripe Element will be inserted here. -->
              </div>
            </div>

            <div class="form-group">
              <input
                v-model="cardholderName"
                :id="$id('cardholder-name')"
                :class="['form-control', nameError ? 'is-invalid' : '']"
                type="text"
                placeholder="Card holder name"
                autocomplete="cc-name"
                :disabled="cardButtonDisable"
                @input="updateName">
              <div v-if="nameError" class="invalid-feedback" role="alert">{{ nameError }}</div>
            </div>

            <div class="form-group">
              <div ref="cardDiv" :class="['form-control', cardError ? 'is-invalid' : '']">
                <!-- A Stripe Element will be inserted here. -->
              </div>
              <div v-if="cardError" class="invalid-feedback" role="alert">{{ cardError }}</div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-primary btn-lg btn-block"
              :data-secret="clientSecret"
              :disabled="cardButtonDisable || cardError != null"
              @click="submitPayment">
              <i class="fas fa-credit-card" aria-hidden="true"></i> Submit Payment
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal stripeModal -->

    <!-- Success Modal -->
    <div
      class="modal fade text-black"
      ref="successModal"
      :id="$id('successModal')"
      tabindex="-1"
      :aria-labelledby="$id('successLabel')"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title font-weight-bold" :id="$id('successLabel')">{{ location.name }} Payment</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-black" style="color: black !important">{{ successMessage }}</p>
          </div>
          <div class="modal-footer">
            <p class="text-black" style="color: black !important">Page will reload in {{ reloadTime }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Success Modal end -->

    <!-- Failure Modal -->
    <div
      class="modal fade text-black"
      ref="failureModal"
      :id="$id('failureModal')"
      tabindex="-1"
      :aria-labelledby="$id('failureLabel')"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title font-weight-bold" :id="$id('failureLabel')">{{ location.name }} Payment</h4>
          </div>
          <div class="modal-body">
            <p class="text-black" style="color: red !important">There has been an issue with communications between Stripe and Tempus. You may have been charged.</p>
          </div>
          <div class="modal-footer">
            <p class="text-black" style="color: black !important">Please get in touch with the branch ASAP!</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Failure Modal end -->
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },

    paymentProviderPublicOptions: {
      type: [Array, Object],
      default: null,
    },
  },

  data() {
    return {
      sale: null,
      saleable: null,
      payingDeposit: false,

      stripe: null,
      elements: null,
      cardholderName: '',
      cardElement: null,
      paymentRequest: null,
      prButton: null,
      prButtonShow: false,
      cardButtonDisable: true,
      prButtonDisable: true,

      amount: null,
      intentId: null,
      clientSecret: null,
      paymentExpiry: null,

      isLoading: true,
      loader: null,
      cardError: null,
      nameError: null,
      successMessage: 'Payment successful.',
      reloadTime: 2,

      currentTimeInterval: null,
      currentTime: moment(),

      confirmCardPaymentStarted: null,

      echoSale: null,
    };
  },

  computed: {
    amountToPay() {
      if (this.amount) {
        return this.amount;
      }

      if (this.sale == null) {
        return 0;
      }

      if (this.payingDeposit) {
        if (this.sale.deposit_amount) {
          return this.sale.deposit_amount;
        }

        return this.sale.sale_items.filter(si => si.saleable_type == 'App\\Models\\Booking').length * 5000;
      }

      return this.sale.left_to_pay;
    },

    timeLeftToPay() {
      if (this.paymentExpiry == null) {
        return null;
      }

      let duration = moment.duration(moment(this.paymentExpiry).subtract(60, 'seconds').diff(this.currentTime));

      return duration;
    },

    timeLeftToPayFormatted() {
      if (this.timeLeftToPay == null) {
        return null;
      }
      if (this.timeLeftToPay < 0) {
        return "00 minutes 00 seconds";
      }

      return this.timeLeftToPay.format('mm [minutes] ss [seconds]', {
        trim: false
      });
    },

    timeExpired() {
      if (this.timeLeftToPay) {
        return this.timeLeftToPay < 0;
      }

      return false;
    },
  },

  watch: {
    sale(newSale, oldSale) {
      if (newSale) {
        if (oldSale == null) {
          this.echoInitSale(newSale);
        } else if (oldSale.id != newSale.id) {
          this.echoDeInitSale(oldSale);
          this.echoInitSale(newSale);
        }
        // this.createPaymentRequest();
        this.createIntent();
      } else {
        this.amount = null;
        this.clientSecret = null;
        this.paymentExpiry = null;
        this.paymentRequest = null;
        this.prButtonShow = false;
        this.cardholderName = '';
        this.cardElement.clear();
        this.prButton?.destroy();
        this.payingDeposit = false;
        this.echoDeInitSale(oldSale);
      }
    },

    timeExpired(newTimeExpired) {
      if (newTimeExpired) {
        // disable buttons
        this.disableCard();
        this.cardButtonDisable = true;
        this.prButtonDisable = true;
        this.$emit('payment-time-expired')
      } else {
        // enable buttons
        this.enableCard();
        this.cardButtonDisable = false;
        this.prButtonDisable = false;
      }
    },
  },

  methods: {
    /* ===============
     * public methods
     */

    takeSalePayment(sale, allowDepositFlag = false) {
      this.sale = sale;
      this.payingDeposit = allowDepositFlag;
      this.$emit('log-payment-provider-message', {message: 'takeSalePayment', saleId: this.sale.id});

      this.showStripeModal();
    },

    takeBookingPayment(booking) {
      // console.log(booking);
      this.sale = booking.sale
      this.saleable = booking;
      this.$emit('log-payment-provider-message', {message: 'takeBookingPayment', saleId: this.sale.id});

      this.showStripeModal();

      // start expire timer
    },

    takeVoucherPayment(voucher) {
      this.sale = voucher.sale
      this.saleable = voucher;
      this.$emit('log-payment-provider-message', {message: 'takeVoucherPayment', saleId: this.sale.id});

      this.showStripeModal();
    },

    takeVirtualGamePayment(virtualGame, sale, from) {
      this.sale = sale;
      this.saleable = virtualGame;
      this.$emit('log-payment-provider-message', {message: 'takeVirtualGamePayment', saleId: this.sale.id});

      this.showStripeModal();
    },

    /*
     * END public methods
     * =============== */

    /* ===============
     * stripeModal methods
     */

    showStripeModal() {
      // Do any prep before showing the modal
      this.cardholderName = this.sale?.customer?.name;

      $(this.$refs.stripeModal).modal('handleUpdate');
      $(this.$refs.stripeModal).modal('show');
    },

    hideStripeModal() {
      $(this.$refs.stripeModal).modal('hide');
    },

    stripeModalShown() {
      // console.log('stripeModalShown');
    },

    stripeModalHidden() {
      // console.log('stripeModalHidden');
      this.sale = null;
    },

    /*
     * END stripeModal methods
     * =============== */

    cardElementChange(event) {
      if (event.error) {
        this.$emit('log-payment-provider-message', {message: 'cardElementChange: error', saleId: this.sale.id, error: event.error});
        this.cardError = event.error.message;
      } else {
        this.$emit('log-payment-provider-message', {message: 'cardElementChange: null error'});
        this.cardError = null;
      }
    },

    createPaymentRequest() {
      if (this.sale == null) {
        return;
      }

      // paymentRequest button for apple pay, google wallet, etc
      let displayItems = [];
      this.sale.sale_items.forEach(saleItem => {
        displayItems.push({
          label: saleItem.saleable.description,
          amount: saleItem.sold_for,
        });
      });

      let currency = this.$currencyCode.toLowerCase();
      if (this.paymentProviderPublicOptions.hasOwnProperty('currency')) {
        currency = this.paymentProviderPublicOptions.currency;
      }
      let country = 'GB';
      if (this.paymentProviderPublicOptions.hasOwnProperty('country')) {
        country = this.paymentProviderPublicOptions.country;
      }

      this.paymentRequest = this.stripe.paymentRequest({
        country: country,
        currency: currency.toLowerCase(),
        total: {
          label: this.location.name,
          amount: this.amountToPay,
        },
        displayItems: displayItems,
        requestPayerName: true,
        requestPayerEmail: true,
      });

      this.prButton = this.elements.create('paymentRequestButton', {
        paymentRequest: this.paymentRequest,
      });
      this.prButton.on('click', (event) => {
        if (this.prButtonDisable) {
          event.preventDefault();
          return;
        }
      });

      // Check the availability of the Payment Request API first.
      this.paymentRequest.canMakePayment().then((result) => {
        if (result) {
          this.prButtonShow = true;
          this.prButton.mount(this.$refs.paymentRequestButton);
        } else {
          this.prButtonShow = false;
        }
      });

      this.paymentRequest.on('paymentmethod', this.submitPaymentRequest);
    },

    createIntent() {
      if (this.sale == null) {
        return;
      }

      let intent = {
        locationId: this.location.id,
        saleId: this.sale.id,
        payDeposit: this.payingDeposit,
      };

      this.loading(true, this.$refs.stripeModal);
      this.$emit('log-payment-provider-message', {message: 'createIntent', saleId: this.sale.id});

      axios.post(this.route('api.stripe.make-intent'), intent)
        .then((response) => {
          if (response.status == '201') { // HTTP_CREATED
            // pull out pi and client secret
            this.amount = response.data.amount;
            this.intentId = response.data.intentId;
            this.clientSecret = response.data.clientSecret;
            this.paymentExpiry = response.data.paymentExpiry;
            this.$emit('log-payment-provider-message', {message: 'createIntent: response: 201', saleId: this.sale.id, intentId: this.intentId, paymentExpiry: this.paymentExpiry});

            if (this.paymentRequest) {
              this.$emit('log-payment-provider-message', {message: 'createIntent: response: 201, updating paymentRequest', saleId: this.sale.id});
              this.paymentRequest.update({
                total: {
                  label: this.location.name,
                  amount: this.amount,
                },
              });
            }

            // enable buttons
            this.enableCard();
            this.cardButtonDisable = false;
            this.prButtonDisable = false;
          } else {
            flash('Error setting up payment', 'danger');
            this.$emit('log-payment-provider-message', {message: 'createIntent: response: 20x error', saleId: this.sale.id});
            console.log('createIntent', response.data);
            console.log('createIntent', response.status);
            console.log('createIntent', response.statusText);
          }
          this.loading(false);
        })
        .catch((error) => {
          flash('Error setting up payment', 'danger');
          this.$emit('log-payment-provider-message', {message: 'createIntent: saleId: catch error', saleId: this.sale.id, error: error});
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            console.log('createIntent: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('createIntent: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('createIntent: Error', error.message);
          }

          // this.loading(false);
        });
    },

    updateName() {
      this.nameError = null;
    },

    enableCard() {
      this.$emit('log-payment-provider-message', {message: 'enableCard', saleId: this.sale.id});
      this.cardElement.update({
        disabled: false,
      });
    },

    disableCard() {
      this.$emit('log-payment-provider-message', {message: 'disableCard', saleId: this.sale.id});
      this.cardElement.update({
        disabled: true,
      });
    },

    submitPayment() {
      this.$emit('log-payment-provider-message', {message: 'submitPayment: pre validation', saleId: this.sale.id});

      // card input box
      if (! this.cardholderName) {
        this.nameError = 'Card holder name is required.';
        this.$emit('log-payment-provider-message', {message: 'submitPayment: nameError', saleId: this.sale.id});

        return;
      }

      this.loading(true, this.$refs.stripeModal);
      this.cardButtonDisable = true;
      this.cardError = null;
      this.disableCard();
      this.prButtonDisable = true;

      // about to attempt taking monies (this will trigger 3DS)
      // TODO: hit up back end to add 2 mins and check we can still sell?

      this.confirmCardPaymentStarted = moment();

      this.$emit('log-payment-provider-message', {message: 'submitPayment: confirmCardPayment:', saleId: this.sale.id});

      this.stripe.confirmCardPayment(
        this.clientSecret,
        {
          payment_method: {
            card: this.cardElement,
            billing_details: {name: this.cardholderName}
          }
        }
      ).then((result) => {
        this.$emit('log-payment-provider-message', {message: 'submitPayment: confirmCardPayment: result', saleId: this.sale.id, intentId: this.intentId, result: result});

        if (result.error) {
          this.confirmCardPaymentStarted = null;

          // Display error.message in your UI.
          // console.log('submitPayment: error', result.error);
          flash('Payment error: ' + result.error.message, 'warning');
          this.cardError = result.error.message;
          this.enableCard();
          this.cardElement.focus();
          this.prButtonDisable = false;
          this.cardButtonDisable = false;
          this.loading(false);
        } else {
          // The payment has succeeded. Display a success message.
          this.paymentSuccess(result);
        }
      });
    },

    submitPaymentRequest(event) {
      // apple pay, google wallet, etc
      this.cardButtonDisable = true;
      this.cardError = null;
      this.disableCard();

      this.$emit('log-payment-provider-message', {message: 'submitPaymentRequest: confirmCardPayment', saleId: this.sale.id});

      // Confirm the PaymentIntent without handling potential next actions (yet).
      this.stripe.confirmCardPayment(
        this.clientSecret,
        {payment_method: event.paymentMethod.id},
        {handleActions: false}
      ).then((confirmResult) => {
        this.$emit('log-payment-provider-message', {message: 'submitPaymentRequest: confirmCardPayment: result', saleId: this.sale.id, intentId: this.intentId, confirmResult: confirmResult});

        if (confirmResult.error) {
          // Report to the browser that the payment failed, prompting it to
          // re-show the payment interface, or show an error message and close
          // the payment interface.
          event.complete('fail');
        } else {
          // Report to the browser that the confirmation was successful, prompting
          // it to close the browser payment method collection interface.
          event.complete('success');
          // Check if the PaymentIntent requires any actions and if so let Stripe.js
          // handle the flow. If using an API version older than "2019-02-11" instead
          // instead check for: `paymentIntent.status === "requires_source_action"`.
          if (confirmResult.paymentIntent.status === "requires_action") {
            this.$emit('log-payment-provider-message', {message: 'submitPaymentRequest: confirmCardPayment: result requires_action', saleId: this.sale.id, intentId: this.intentId});
            // Let Stripe.js handle the rest of the payment flow.
            this.stripe.confirmCardPayment(this.clientSecret).then(function(result) {
              this.$emit('log-payment-provider-message', {message: 'submitPaymentRequest: confirmCardPayment: result requires_action result', saleId: this.sale.id, intentId: this.intentId, result: result});

              if (result.error) {
                // The payment failed -- ask your customer for a new payment method.
                flash('Payment error: ' + result.error.message, 'warning');

                this.cardError = result.error.message;
                this.enableCard();
                this.cardElement.focus();
                this.cardButtonDisable = false;
              } else {
                // The payment has succeeded.
                this.paymentSuccess(result);
              }
            });
          } else {
            // The payment has succeeded.
            this.paymentSuccess(result);
          }
        }
      });
    },

    paymentSuccess(result) {
      console.log('paymentSuccess: ', result);
      this.$emit('log-payment-provider-message', {message: 'paymentSuccess:', saleId: this.sale.id, result: result});

      // let backend know?
      let intent = {
        locationId: this.location.id,
        saleId: this.sale.id,
        intentId: this.intentId,
      };

      this.loading(true, this.$refs.stripeModal);

      this.$emit('log-payment-provider-message', {message: 'paymentSuccess: intent-success', saleId: this.sale.id});

      axios.post(this.route('api.stripe.intent-success'), intent)
        .then((response) => {
          this.$emit('log-payment-provider-message', {message: 'paymentSuccess: intent-success response', saleId: this.sale.id, response: response});
          if (response.status == '202') { // HTTP_ACCEPTED
            console.log('paymentSuccess: accepted');
          } else if (response.status == '204') { // HTTP_NO_CONTENT
            console.log('paymentSuccess: confirmed');
          } else {
            flash('Error reporting payment success', 'danger');
            console.log('paymentSuccess', response.data);
            console.log('paymentSuccess', response.status);
            console.log('paymentSuccess', response.statusText);
          }

          this.loading(false);
          this.paymentSuccessConfirmed();
        })
        .catch((error) => {
          flash('There has been an issue with logging your payment...', 'danger');
          this.$emit('log-payment-provider-message', {message: 'paymentSuccess: intent-success catch error', saleId: this.sale.id, error: error});
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            console.log('paymentSuccess: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('paymentSuccess: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('paymentSuccess: Error', error.message);
          }

          this.loading(false);
          this.paymentSuccessError(result);
        });
    },

    paymentSuccessConfirmed() {
      this.$emit('log-payment-provider-message', {message: 'paymentSuccessConfirmed reloadPageTimer:', saleId: this.sale.id});
      // refresh page
      // sale gets nulled, so need to send this to the reload page timer
      this.reloadPageTimer(Vue.util.extend({}, JSON.parse(JSON.stringify(this.sale))));

      // swap modal
      this.hideStripeModal();
      $(this.$refs.successModal).modal('show');
    },

    paymentSuccessError(result) {
      console.log('paymentSuccessError', result);
      console.log('paymentSuccessError: result.paymentIntent.id', result.paymentIntent.id); // pi_?????????
      this.$emit('log-payment-provider-message', {message: 'paymentSuccessError:', saleId: this.sale.id, result: result});

      this.loading(true, this.$refs.stripeModal);

      // stripeTransactionPaymentIntentIds

      // Stripe was successful, Tempus was not - we have an error
      // we need to see if the webhook has arrived, and it's been published over Echo

      // has the sale been updated by echo already?
      do {
        if (this.echoSale !== null) {
          // echo has given us an updated sale
          let paymentIntentTransaction = this.echoSale.stripeTransactionPaymentIntentIds.find(stripeTransactionPaymentIntentId => stripeTransactionPaymentIntentId == result.paymentIntent.id);
          if (paymentIntentTransaction) {
            this.loading(false);
            this.paymentSuccessConfirmed();

            return;
          }
        }
        this.sleep(1000);
      } while (moment().isBefore(this.confirmCardPaymentStarted.clone().add(15, 'seconds')));

      this.$emit('log-payment-provider-message', {message: 'paymentSuccessError: public-show', saleId: this.sale.id});
      // we have waited for long enough, echo should have fired, the sale was successful but we don't have any trace
      axios.get(this.route('api.sales.public-show', this.sale))
        .then((response) => {
          console.log('PayStripe::refreshSale axios: response.data', response.data)
          this.$emit('log-payment-provider-message', {message: 'paymentSuccessError: public-show response', saleId: this.sale.id});
          if (response.status == 200) {
            let paymentIntentTransaction = response.data.stripeTransactionPaymentIntentIds.find(stripeTransactionPaymentIntentId => stripeTransactionPaymentIntentId == result.paymentIntent.id);
            if (paymentIntentTransaction) {
              this.loading(false);
              this.paymentSuccessConfirmed();

              return;
            }

            // we have exhausted all possibilities
            // tell the customer to contact the branch
            this.loading(false);
            this.successfulPaymentWithErrorsModal();

          } else {
            flash('Error refreshing Sale', 'danger');
            console.log('refreshSale', response.data);
            console.log('refreshSale', response.status);
            console.log('refreshSale', response.statusText);
          }
        })
        .catch((error) => {
          this.$emit('log-payment-provider-message', {message: 'paymentSuccessError: public-show catch error', saleId: this.sale.id, error: error});
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('refreshSale:401', error.response.data);
            }
            else if (error.response.status == 404) {
              // 404 not found
              console.log('BookingCheckoutIframe::refreshSale - Sale not found');
            }
            console.log('refreshSale: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('refreshSale: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('refreshSale: Error', error.message);
          }

          this.loading(false);
          this.successfulPaymentWithErrorsModal();
        });
    },

    reloadPageTimer(sale) {
      if (this.reloadTime <= 0) {
        window.location.href = this.route('location.payment.success', [this.location, sale]); // redirect to .... payment success page
      } else {
        setTimeout(() => {
          this.reloadTime -= 1;
          this.reloadPageTimer(sale);
        }, 1000);
      }
    },

    successfulPaymentWithErrorsModal() {
      this.$emit('log-payment-provider-message', {message: 'successfulPaymentWithErrorsModal:', saleId: this.sale.id});
      this.cardError = 'Data communication failure, contact branch';
      this.hideStripeModal();

      flash('Data communication failure, contact branch', 'warning');
      $(this.$refs.failureModal).modal('show');
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    /* ===============
     * Echo methods
     */

    echoInitSale(sale) {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      if (sale == null) {
        return;
      }

      Echo.channel('sale.' + sale.hashid)
        .listen('Sale.SaleUpdated', this.saleUpdatedEvent)
        .listen('Sale.SaleDeleted', this.saleDeletedEvent);
    },

    echoDeInitSale(sale) {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      if (sale == null) {
        return;
      }

      Echo.leave('sale.' + sale.hashid);
    },

    saleUpdatedEvent(event) {
      console.log('saleUpdatedEvent(event)', event);

      // we have received an update of this sale
      // we want to keep hold of this data, so that the response has time to do its thing, or fail
      this.echoSale = event.sale;
    },

    saleDeletedEvent(event) {
      console.log('saleDeletedEvent(event)', event);

      this.echoSale = null;
      this.successfulPaymentWithErrorsModal();
    },

    /*
     * END Echo methods
     * =============== */
  },

  mounted() {
    this.$nextTick(function () {
      $(this.$refs.vueRemove).contents().unwrap();
    });

    $(this.$refs.stripeModal).modal('handleUpdate');
    $(this.$refs.stripeModal).on('hidden.bs.modal', this.stripeModalHidden);
    $(this.$refs.stripeModal).on('shown.bs.modal', this.stripeModalShown);
    $(this.$refs.successModal).modal('handleUpdate');

    this.stripe = Stripe(this.paymentProviderPublicOptions.stripeKey),
    this.elements = this.stripe.elements();

    // main stripe card input
    this.cardElement = this.elements.create('card', {
      disabled: true,
    });
    this.cardElement.mount(this.$refs.cardDiv)
    this.cardElement.on('change', this.cardElementChange);

    this.currentTimeInterval = setInterval(() => {
      this.currentTime = moment(); // TODO: make as server timezone / same zone as paymentExpiry
    }, 100);
  },

  beforeDestroy() {
    this.$emit('log-payment-provider-message', {message: 'beforeDestroy:', saleId: this.sale.id});
    clearInterval(this.currentTimeInterval);
  },
};
</script>
